import React from "react";
import { Container } from "meta/ui2/layout";
const TopLeftMenu = ({ appName, serverName, showEmergency }) => (<Container id="top-left-container">
    {showEmergency ? (<span className="top-warning">EMERGENCY ACCESS MODE</span>) : (<span id="app-title" dangerouslySetInnerHTML={appName}></span>)}
    <span id="server-name" dangerouslySetInnerHTML={serverName}></span>
  </Container>);
export default TopLeftMenu;
